<template>
  <div style="background-color: #edf4fc;">
    <div class="content-title">
      <span style="font-size: 0.3rem; line-height: 0.6rem">管理类专业硕士简介</span>
      <br />
      <span style="font-size: 0.15rem">为用户提供管理类专业硕士的简单介绍、培养目标、专业方向等内容。</span>
    </div>
    <div class="content-body">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">MBA</div>
              <p class="content-body-box-2">工商管理硕士，全称为工商管理专业型硕士研究生、工商管理专业学位硕士研究生（英文名：Master of Business Administration，简称MBA）。是对应工商管理学术型硕士（专业代码125100）的专业学位硕士，该学位的设立，旨在培养未来能够胜任工商企业和经济管理部门高层管理工作需要的务实型、复合型和应用型高层次管理人才。根据《教育部办公厅关于统筹全日制和非全日制研究生管理工作的通知》，从2017年起，教育部会同国家发展改革委按全日制和非全日制两类分别编制和下达全国博士、硕士研究生招生计划。全日制和非全日制研究生考试招生依据国家统一要求，执行相同的政策和标准。</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">MEM</div>
              <p class="content-body-box-2">工程管理硕士（Master of Engineering Management，简称MEM），专业代码125600。是2010年由中国工程院提议，委托清华大学进行学科论证，同年批复新设置的一种专业学位。工程管理是针对工程实践而进行的决策、计划、组织、指挥、协调与控制。</p>
              <p class="content-body-box-2" style="margin-bottom: 0;">工程管理硕士下属专业：</p>
              <div style="margin-left: 0.25rem;">
                <div style="float: left;padding: 0.05rem;">
                  <el-popover
                    placement="top-start"
                    title="MEM-125601"
                    width="200"
                    trigger="hover"
                    content="工程管理专业是一个管理学分支的学科 ，指在工程活动中运用专门的知识、技能、工具和方法，使工程能够在有限资源限定条件下，实现或超过设定的需求和期望。">
                    <el-button slot="reference">工程管理</el-button>
                  </el-popover>
                </div>
                <div style="float: left;padding: 0.05rem;">
                  <el-popover
                    placement="bottom"
                    title="MEM-125602"
                    width="200"
                    trigger="hover"
                    content="项目管理硕士是专业硕士学位的一类，研究、从事的领域包括项目整体管理、项目时间管理、项目成本管理、项目质量管理、项目风险管理等。">
                    <el-button slot="reference">项目管理</el-button>
                  </el-popover>
                </div>
                <div style="float: left;padding: 0.05rem;">
                  <el-popover
                    placement="top-start"
                    title="MEM-125603"
                    width="200"
                    trigger="hover"
                    content="工业工程与管理专业硕士是一门综合性的学科，旨在培养具备工业工程和管理知识的高级人才。工业工程与管理专业硕士的培养目标是培养具备工程技术和管理知识的高级人才，能够在企事业单位中从事工业工程和管理工作。">
                    <el-button slot="reference">工业工程与管理</el-button>
                  </el-popover>
                </div>
                <div style="float: left;padding: 0.05rem;">
                  <el-popover
                    placement="bottom"
                    title="MEM-125604"
                    width="200"
                    trigger="hover"
                    content="物流工程与管理是一个广泛的领域，涉及到物流系统的设计、运营和优化。物流工程与管理的目标是通过优化这些环节来提高整个物流系统的效率和效益，最大化物流成本和服务质量的平衡。">
                    <el-button slot="reference">物流工程与管理</el-button>
                  </el-popover>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">MPA</div>
              <p class="content-body-box-2">公共管理硕士（Master of Public Administration，缩写为MPA），又译公共行政硕士（台），是为适应社会公共管理现代化、科学化和专业化的要求而设立的学科，其培养目标是为政府部门及公共机构培养德才兼备、适应社会主义现代化建设需要的高层次、应用型、复合型的管理人才。要求毕业生成为掌握先进分析方法及技术，熟悉具体公共管理或政策领域的领导者，管理者以及其他公共服务人才。公共管理学是一门运用管理学、政治学、经济学等多学科理论与方法，专门研究公共组织尤其是政府组织的管理活动及其规律的学科体系。</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">MTA</div>
              <p class="content-body-box-2">旅游管理硕士专业学位（MTA，Master of Tourism Administration）是教育部从2010年开始设立的旨在培养旅游及其相关产业高层次应用型人才的教育项目。 [1]在我国旅游业迅速发展的大背景下，经国务院学位委员会于2010年3月批准设置旅游管理硕士（MTA，Master of Tourism Administration） [1]。2010年9月，MTA被国家列入2011年全国研究生统一招生计划，允许在全国24个省、直辖市和自治区的57个MTA授权点进行招生。全国MTA教育指导委员会秘书处挂靠在南开大学。</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">EMBA</div>
              <p class="content-body-box-2">高级管理人员工商管理硕士（英文名：Executive Master of Business Administration，简称EMBA），旨在培养具有高度政治素养、责任心和职业道德、能够胜任工商企业和经济管理部门高层管理工作需要的中、高层管理者。根据《教育部办公厅关于统筹全日制和非全日制研究生管理工作的通知》，从2017年起，教育部取消了EMBA自主招生，纳入全国硕士研究生统一招生考试，全日制和非全日制研究生考试招生依据国家统一要求，执行相同的政策和标准。专业代码：125100（工商管理）；同年，明确规定了全日制和非全日制MBA及EMBA均可获得学历证和学位证，学历类型均为统招学历（普通高等教育）。</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">MPAcc</div>
              <p class="content-body-box-2">会计硕士（Master of Professional Accounting），是一项专业学位，是为了培养面向会计职业的应用型高层次会计人才，健全和完善我国高层次会计人才培养体系，建设高素质的会计人才队伍，以更好地适应社会主义市场经济发展和经济全球化的需要，为全面建设小康社会服务，为实施科教兴国战略和人才强国战略服务。根据《教育部办公厅关于统筹全日制和非全日制研究生管理工作的通知》，从2017年起，教育部会同国家发展改革委按全日制和非全日制两类分别编制和下达全国博士、硕士研究生招生计划。全日制和非全日制研究生考试招生依据国家统一要求，执行相同的政策和标准。</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">MAud</div>
              <p class="content-body-box-2">审计硕士（MAud）于2011年2月13日国务院学位委员会第28次会议审议通过设置该硕士。审计硕士专业学位（MAud）是为了适应我国社会经济发展对审计专门人才的迫切需求，完善审计人才培养体系，提高审计人才培养质量而设置的专业学位。审计硕士专业学位培养目标是：培养具备良好的政治思想素质和职业道德素养，系统掌握现代审计学基本理论及相关领域的知识和技能，具有开阔的国际视野、较强的专业能力、能够创造性地从事审计工作的高层次、应用型审计专门人才。</p>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="content-body-box">
              <div class="content-body-box-1">Mlis</div>
              <p class="content-body-box-2">图书情报硕士专业学(Master of Library and Information Studies，简称Mlis)，是管理学领域下针对图书情报人才培养的专业学位专业，于2010年1月设置。图书情报硕士专业学（Mlis）是为了适应新形势图书情报事业发展对图书情报专门人才的迫切需求，完善图书情报人才培养体系，创新图书情报人才培养模式，提高图书情报人才培养质量而设置的专业学位。图书情报硕士专业学位培养目标是：培养具有综合运用管理、经济、法律、计算机等知识解决图书情报工作实际问题能力，适应社会信息化和国民经济建设需要的高层次、应用型、复合型图书情报专门人才。</p>
            </div>
          </el-col>
        </el-row>
      </div>
  </div>
</template>

<script>
// 按需导入 API 接口

export default {
  name: 'Introduction',
  data() {
    return {

    }
  },
  created() {
  },
  // 导航离开该组件的对应路由时调用
  // 可以访问组件实例 `this`
  beforeRouteLeave(to, from, next) {
    from.meta.top = window.scrollY
    setTimeout(() => {
      next()
    }, 0)
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
a {
  color: #000000;
  text-decoration: none;
}
a p div span {
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Microsoft YaHei","Hiragino Sans GB","WenQuanYi Micro Hei",Arial,sans-serif;
}
.content-title {
  text-align: center;
  color: #303133;
  height: 1rem;
  background-color: rgb(188, 247, 220);
}
.content-body {
  overflow: hidden;
  margin: 0.1rem;
}
.content-body-box {
  height: 2.3rem;
  margin-bottom: 0.2rem;
  margin-right: 0!important;
  background-color: rgb(247, 247, 247);
  border-radius: 0.1rem;
  border: 1px solid rgb(216, 215, 215);
  overflow: auto;
}
.content-body-box-1 {
  margin: 0.1rem;
  font-size: 0.13rem;
  text-align: center;
  color: red;
}
.content-body-box-2 {
  margin: 0.1rem;
  font-size: 0.13rem;
  text-indent: 0.26rem;
  text-align:justify;
  line-height: 1.6;
}
</style>
